import { render } from "./SBPIcon.vue?vue&type=template&id=f2c83894&ts=true"
import script from "./SBPIcon.vue?vue&type=script&lang=ts"
export * from "./SBPIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__